import { FALLBACK_IMAGE_MD, LazyImage } from "@website/ui/lazy-image";
import { getImage } from "@website/utils/get-image";
import { ReserveGalleryDetailPropertiesTypes } from "@website/widget/reserve-gallery-detail/reserve-gallery-detail.types";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
import { useEffect } from "react";

const ImageElementComponent = ({
  img,
  className
}: {
  img: {
    id: number | string;
    media: string;
    title: string;
  };
  className: string;
}) => {
  const router = useRouter();
  const setIsModalOpen = (status: boolean, item?: string | number) => {
    sessionStorage?.setItem("selectedImageId", String(item));
    return status
      ? router.push(
          {
            pathname: router.pathname,
            query: {
              ...omit(router?.query, "item"),
              modal: "gallery-details",
              item
            }
          },
          undefined,
          { shallow: true, scroll: false }
        )
      : router.back();
  };
  return (
    <div
      className={className}
      id={`gallery_image_${img?.id}`}
      onClick={setIsModalOpen.bind(null, true, img?.id)}
    >
      <LazyImage
        alt={img?.title}
        className="bg-outline-thin size-full object-cover"
        fallback={FALLBACK_IMAGE_MD.src}
        loading="lazy"
        src={img?.media}
        title={img?.title}
      />
    </div>
  );
};

const ImageElement = ImageElementComponent;

export const ReserveGalleryDetail = (
  properties: ReserveGalleryDetailPropertiesTypes
) => {
  const { gallery, rowCount, index } = properties;
  const router = useRouter();

  useEffect(() => {
    const element = document?.getElementById(
      `gallery_image_${sessionStorage?.getItem("selectedImageId")}`
    );
    element?.scrollIntoView();
  }, [router?.query]);

  useEffect(() => {
    document
      ?.querySelector(
        `#gallery_image_${sessionStorage?.getItem("selectedImageId")}`
      )
      ?.scrollIntoView({ behavior: "smooth" });
  }, []);

  if (rowCount === 1) {
    return gallery.slice(index).map((img) => (
      <ImageElement
        className="bg-outline-thin col-span-2 row-span-2 min-h-[364px]"
        img={{
          ...img,
          media: getImage({
            src: img?.media,
            width: 672,
            height: 364
          })
        }}
        key={img.id}
      />
    ));
  }

  if (rowCount === 2) {
    return gallery.slice(index).map((img) => (
      <ImageElement
        className="bg-outline-thin col-span-1 row-span-2 min-h-[364px]"
        img={{
          ...img,
          media: getImage({
            src: img?.media,
            width: 672,
            height: 364
          })
        }}
        key={img.id}
      />
    ));
  }

  if (rowCount === 3) {
    return (
      <>
        <ImageElement
          className="bg-outline-thin col-span-1 row-span-2 min-h-[364px]"
          img={{
            ...gallery?.[index],
            media: getImage({
              src: gallery?.[index]?.media,
              width: 332,
              height: 420
            })
          }}
        />
        {gallery.slice(index + 1).map((img) => (
          <ImageElement
            className="bg-outline-thin col-span-1 row-span-1 min-h-[206px]"
            img={{
              ...img,
              media: getImage({
                src: img?.media,
                width: 332,
                height: 420
              })
            }}
            key={img.id}
          />
        ))}
      </>
    );
  }

  return (
    <>
      <ImageElement
        className="bg-outline-thin col-span-1 row-span-2 min-h-[364px]"
        img={{
          ...gallery?.[index],
          media: getImage({
            src: gallery?.[index]?.media,
            width: 672,
            height: 364
          })
        }}
      />
      <ImageElement
        className="bg-outline-thin col-span-1 row-span-1 min-h-[206px]"
        img={{
          ...gallery?.[index + 1],
          media: getImage({
            src: gallery?.[index + 1]?.media,
            width: 332,
            height: 206
          })
        }}
      />
      <ImageElement
        className="bg-outline-thin col-span-1 row-span-1 min-h-[206px]"
        img={{
          ...gallery?.[index + 2],
          media: getImage({
            src: gallery?.[index + 2]?.media,
            width: 332,
            height: 206
          })
        }}
      />
      <ImageElement
        className="bg-outline-thin col-span-2 row-span-2 min-h-[364px]"
        img={{
          ...gallery?.[index + 3],
          media: getImage({
            src: gallery?.[index + 3]?.media,
            width: 672,
            height: 364
          })
        }}
      />
    </>
  );
};
